import React from "react";
import OptionButtons from "../../../../../../components/buttons/optionsBtn";

const YesNoSingleChoice = ({ answers, handleAnswer, data }) => {
  const currentAnswer = answers?.[data?.refCode];
  const answer1 = currentAnswer?.split("+")?.[0]?.replace(" ", "") ?? "";
  const selectedOption = currentAnswer?.split("+")?.[1]?.replace(" ", "") ?? "";

  const handleOptionSelect = (value) => {
    handleAnswer(answer1 === "Yes" ? `${answer1} + ${value}`:"No");
  };

  return (
    <>
      <div className="yes__no__main">
        <OptionButtons
          selected={answers?.[data?.refCode]}
          onSelect={(label) => {
            handleAnswer(label);   
          }}
        />
      </div>
      {answer1 === "Yes" && (
        <div className="single__choice">
          {["Paid", "Free"].map((option, index) => (
            <div key={index} className="single__main">
              <div className="d-flex align-items-center inner_single">
                <input
                  className={`option ${selectedOption === option ? "selected" : ""}`}
                  onClick={() => handleOptionSelect(option)}
                  type="radio"
                  name={`options-${data?.refCode}`}
                  id={`${data?.refCode}-${option}`}
                  checked={selectedOption === option}
                  readOnly
                />
                <label
                  className={`label ${selectedOption === option ? "selected" : ""}`}
                  htmlFor={`${data?.refCode}-${option}`}
                >
                  {option}
                </label>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default YesNoSingleChoice;
